/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "bell-outline-8994f335--sprite",
  "use": "bell-outline-8994f335--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"bell-outline-8994f335--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><path d=\"M871.82,1058.969h0l-2.34-4.338v-2.34a6.543,6.543,0,0,0-3.74-5.92,2.823,2.823,0,0,0-2.7-2.34,2.909,2.909,0,0,0-2.9,2.36,6.409,6.409,0,0,0-1.8,1.28,6.559,6.559,0,0,0-1.9,4.62v2.34l-2.24,4.04-.14.28v.08a2.024,2.024,0,0,0,.48,2.06,1.937,1.937,0,0,0,1.42.6h3.92a3.11,3.11,0,0,0,.78,1.24,3.235,3.235,0,0,0,4.575.025l.025-.025.02-.02a3.179,3.179,0,0,0,.74-1.22h3.94a2,2,0,0,0,1.86-2.722Zm-14.82.1,1.9-3.46.16-.38v-2.96a3.907,3.907,0,0,1,7.8-.32v3.1l.06.36,2.02,3.66Z\" transform=\"translate(-844.957 -1036.031)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
